import { PortalAllMediaClasses, PortalThemeImage, PortalThemeImageSet } from '@nx-frontend/shared/types';
import { getFixedImageUrl } from '@nx-frontend/shared/utils';

const defaultImageProps: Omit<PortalThemeImage, 'url'> = {
  repeat: 'no-repeat',
  // position: 'center',
  size: 'cover',
};

const imageVarClasses: Record<PortalAllMediaClasses, string> = {
  'base': 'bg-[image:var(--bg-base)]',
  'sm': 'sm:bg-[image:var(--bg-sm)]',
  'md': 'md:bg-[image:var(--bg-md)]',
  'lg': 'lg:bg-[image:var(--bg-lg)]',
  'xl': 'xl:bg-[image:var(--bg-xl)]',
  '2xl': '2xl:bg-[image:var(--bg-2xl)]',
};

const minHeightVarClasses: Record<PortalAllMediaClasses, string> = {
  'base': 'min-h-[var(--min-h-base)]',
  'sm': 'sm:min-h-[var(--min-h-sm)]',
  'md': 'md:min-h-[var(--min-h-md)]',
  'lg': 'lg:min-h-[var(--min-h-lg)]',
  'xl': 'xl:min-h-[var(--min-h-xl)]',
  '2xl': '2xl:min-h-[var(--min-h-2xl)]',
};

export function getHeaderClassNames(images?: PortalThemeImageSet): string[] {
  if (images == null || images.enabled === false) {
    return [];
  }
  return Object.values(PortalAllMediaClasses).reduce<string[]>((acc, key) => {
    const media = key as PortalAllMediaClasses;
    const image = images[media];
    if (image == null) {
      return acc;
    }
    const props = media === PortalAllMediaClasses.BASE ? { ...defaultImageProps, ...image } : image;
    const prefix = media === PortalAllMediaClasses.BASE ? '' : `${media}:`;
    acc.push(
      ...[
        imageVarClasses[media],
        ...(props.size != null ? [`${prefix}bg-${props.size}`] : []),
        ...(props.repeat != null ? [`${prefix}bg-${props.repeat}`] : []),
        // ...(props.position != null ? [`${prefix}bg-${props.position}`] : []),
        ...(props.minHeight != null ? [minHeightVarClasses[media]] : []),
      ]
    );
    return acc;
  }, images.classNames || []);
}

export function getHeaderStyles(images?: PortalThemeImageSet): Record<string, string> {
  if (images == null || images.enabled === false) {
    return {};
  }
  return Object.values(PortalAllMediaClasses).reduce<Record<string, string>>((acc, media) => {
    const image = images[media as PortalAllMediaClasses];
    if (image == null) {
      return acc;
    }
    acc[`--bg-${media}`] = `url('${getFixedImageUrl(image.url)}')`;
    if (image.minHeight != null) {
      acc[`--min-h-${media}`] = `${image.minHeight}px`;
    }
    return acc;
  }, {});
}
